import { H2, H3, Paragraph, SmallText } from '../../components/typography/Typography'
import stadiumHero from '../../assets/stadium-hero.webp'

const reasons = [
    {
        title: 'Engineered for Indian venues',
        description: 'Spans, spatial constraints and regulatory standards are worked out for the building you already have.',
    },
    {
        title: 'Customized For You',
        description: 'Frames, mechanisms and seats are customized to your CAD files, so tolerances and lead times stay under our control.',
    },
    {
        title: 'Service that shows up',
        description: 'Local teams for commissioning, annual maintenance and spares — not a distributor in another country.',
    },
    {
        title: 'Specified with your architect',
        description: 'Drawings, load calculations and sightline studies issued before anything is cut.',
    },
]

export const WhyXtractPro = () => {
    return (
        <section className='bg-dark-1 px-4 py-12 md:px-24 md:py-16'>
            {/* Desktop splits the heading off to the left so the rows keep a readable
                measure instead of stretching the full page width. */}
            <div className='flex flex-col gap-8 md:gap-12 lg:flex-row lg:items-start lg:gap-16'>
                <div className='flex flex-col gap-4 lg:w-2/5 lg:shrink-0'>
                    <SmallText className='tracking-[0.25em] text-my-orange'>Why XtractPro</SmallText>
                    <H2 className='max-w-2xl text-white'>Completely Customized, Wherever You Are</H2>
                    {/* Desktop only — on narrower screens the heading sits straight on
                        top of the list, as in the reference. The cutout has a
                        transparent backdrop, so the rows read as rising out of the band. */}
                    <img
                        src={stadiumHero}
                        alt='Tiered rows of XtractPro stadium seating'
                        width={1232}
                        height={928}
                        loading='lazy'
                        decoding='async'
                        className='mt-4 hidden w-full object-contain lg:block'
                    />
                </div>

                <ol className='flex flex-1 flex-col border-t border-gray-800'>
                    {reasons.map(({ title, description }, index) => (
                        <li
                            key={title}
                            className='flex flex-row gap-5 border-b border-gray-800 py-6 md:gap-8 md:py-8 lg:py-6'
                        >
                            <SmallText className='shrink-0 pt-1 tracking-normal text-my-orange'>
                                {String(index + 1).padStart(2, '0')}
                            </SmallText>
                            <div className='flex flex-col gap-2'>
                                <H3 className='font-normal text-white'>{title}</H3>
                                <Paragraph className='text-gray-500 lg:text-lg'>{description}</Paragraph>
                            </div>
                        </li>
                    ))}
                </ol>
            </div>
        </section>
    )
}
